import { useContext } from 'react';
import { PapleContext } from './PaypleProvider';
export const usePayple = () => {
  const paypleContext = useContext(PapleContext);
  if (!paypleContext) {
    throw new Error('ServerSideProps context must be use inside ServerSidePropsProvider');
  }
  return paypleContext;
};